import { Box, H5 } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

import WorkspacePropType from "src/custom-prop-types/workspace";

import { copywriting } from "../ReportTeamChange.config";
import { addSenderToMessage } from "../ReportTeamChange.util";
import ReportTeamChangeSearch from "./ReportTeamChangeSearch";

const MissingTeam = ({ onUpdateNewTeams, sender, workspace }) => {
  const onOptionSelect = (value) => {
    onUpdateNewTeams(value || []);
  };

  return (
    <Box>
      <H5 weight="bold" pb={4}>
        {addSenderToMessage(sender, copywriting.NOT_IN_TEAM)}
      </H5>
      <ReportTeamChangeSearch
        entityType="teams"
        onOptionSelect={onOptionSelect}
        workspace={workspace}
      />
    </Box>
  );
};

MissingTeam.propTypes = {
  onUpdateNewTeams: PropTypes.func,
  sender: PropTypes.string,
  workspace: WorkspacePropType,
};

export default MissingTeam;
